module.exports = __webpack_public_path__ + "static/media/light_logo.1e534cd9.png";